import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut } from "lucide-react";
import { Button } from "./ui/button";

export const LIMA_LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_legal-exposure-map/artifacts/6yqg27cj_1001339042-1.png";

export default function LimaHeader() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-30 backdrop-blur-xl bg-white/90 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-3">
          <img src={LIMA_LOGO} alt="Lima SST" className="h-12 md:h-14 w-auto" />
          <div className="hidden md:block border-l border-slate-200 pl-3 ml-1">
            <div className="text-[10px] tracking-[0.28em] text-slate-500 font-semibold">DIAGNÓSTICO</div>
            <div className="font-display font-black text-sm text-[#10243f] leading-tight">Motor Adaptativo de SST</div>
          </div>
        </Link>
        {user ? (
          <div className="flex items-center gap-4">
            {user.is_admin && (
              <a href="/admin" data-testid="header-admin-link"
                 className="text-xs uppercase tracking-widest font-bold text-[#c7a45a] hover:text-[#10243f] transition-colors">
                Consultor Lima
              </a>
            )}
            <span className="text-sm text-slate-600 hidden sm:inline" data-testid="header-user-name">{user.name}</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => { logout(); nav("/login"); }}
              data-testid="logout-btn"
              className="text-slate-700"
            >
              <LogOut size={16} className="mr-2" /> Sair
            </Button>
          </div>
        ) : (
          <Button
            onClick={() => nav("/login")}
            className="bg-[#10243f] hover:bg-[#19385e] text-white"
            data-testid="login-btn-header"
          >
            Entrar
          </Button>
        )}
      </div>
    </header>
  );
}
